<template>
    <div>
        <header-portrate />
    <div class="m-2">
        <bread-crumbs :items="items" />
        <tabs-comp :tabs="tabs" style="margin-top:60px !important;" />
        <v-row class="m-2">
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="tablerows"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    width="100%"
                    id="MainTable"
                >
                    <template v-slot:item="row">
                        <tr>
                            <td style="width:10%;" class="text-center">{{ row.item.itemcode }}</td>
                            <td style="width:60%;" class="text-start" nowrap>{{ row.item.name }}</td>
                            <td style="width:10%;" class="text-center">{{ row.item.qty }}</td>
                            <td style="width:10%;" class="text-center">{{ row.item.ftotal }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <vue-snotify></vue-snotify>
    </div>

        <Footer />
    </div>
</template>

<script>
import axios from 'axios'
import breadCrumbs from '@/components/breadCrumbs.vue';
import TabsComp from '@/components/tabsComp.vue';
import Footer from '@/components/Footer.vue';
import HeaderPortrate from '@/components/Header-Portrate.vue'
import { getVisibleTabsForRoute } from '@/menu/menuService'
export default{
  components: { breadCrumbs, TabsComp,Footer,HeaderPortrate },
    name: 'Products',
    data() {
        return {
            sortBy: 'qty',
            sortDesc: false,
            active_tab:2,
            items: [
                // {text: this.$store.state.hometitle, disabled: false, to: '/home'},
                // {text: 'المخزون', disabled: false, to: '/inventory/products'},
                {text: 'الاصناف الاقل مبيعا', disabled: true, to: '/inventory/lowest-selling'},
            ],

            headers: [
                {
                    text: 'رقم القطعة',
                    align: 'center',
                    filterable: false,
                    value: 'itemcode',sortable: false,
                },
                {
                    text: 'الاسم',
                    align: 'center',
                    filterable: false,
                    value: 'name',sortable: false,
                },
                {
                    text: 'الكمية المباعة',
                    align: 'center',
                    filterable: false,
                    value: 'qty',sortable: false,
                },
                {
                    text: 'اجمالي البيع',
                    align: 'center',
                    filterable: false,
                    value: 'ftotal',sortable: false,
                },
            ],
            tablerows: [

            ],

        }
    },
    created() {
        this.getProducts();
    },
    methods: {
        calcTo () {
            const xy = this.$store.state.products;
            // this.tablerows = this.$store.state.products;
            for(let i=0;i<xy.length;i++){
                const ss = parseFloat(xy[i].price) * parseFloat(xy[i].qty);
                const y = {
                    itemcode: xy[i].itemcode,
                    name: xy[i].name,
                    qty: xy[i].qty,
                    price: xy[i].price,
                    ftotal: this.$RoundNum(ss)
                };
               this.tablerows.push(y);
            }
        },
        getProducts(){
          const post = new FormData();
          post.append('type','getProductBySale');
          post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
          post.append('auth',this.$cookies.get(this.$COOKIEPhase));
          post.append('data[order]','up');
            axios.post(this.$SAMCOTEC.r_path,post)
          .then((response) => {
              const res = response.data;
              if(res.results.data.items.length > 0){
                  const invo = res.results.data.invo;

                  for(let i=0;i<res.results.data.items.length;i++){
                      const xy = res.results.data.items[i];
                      let qty = 0;
                      let price = 0;

                      const y = {
                            itemcode: xy.itemcode,
                            name: xy.name,
                            qty: invo[xy.itemcode].qty,
                            price: xy.price,
                            ftotal: invo[xy.itemcode].total,
                      };

                    this.tablerows.push(y);
                  }
              }
          });
      },
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        tabs: function() {

            return getVisibleTabsForRoute(this.$store.getters['state'], this.lang, this.$route.path);

        },
    },
}
</script>